import { Container, Dropdown, Navbar, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getProfilePicName } from "helper/common";
import  classes from "./index.module.scss";

import DynamicForm from "components/DynamicForm";
import React, { Fragment, useState ,useEffect } from "react";
import { setSelectedData } from "redux/formDisplay";
import { storeLogoutToken } from "../../api/userAuth";
import { Search } from "lib";
import { debounceFunc } from "helper";
import Download_icon from "assets/images/download_icon.svg";
import { getDashboardListDetails } from "api/dashboard";
import { clearAllFilterCheckBox, dashboardReducer } from "redux/dashboardReducer";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Button from 'react-bootstrap/Button';
import { Row,Col } from 'react-bootstrap';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import FormButton from "components/FormButton";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import NoData from "assets/images/NoData.svg";
import { encryptUrl } from "api/UrlEncryption";

import { validate } from "components/DynamicForm/validate";
import { checkAndChangeDefault, getDashboardFilters, getFilterDropdownList, updateDashboardFilter } from "api/dashboard";
import { setAllFilterCheckBoxList, setDefaultFilter, setFilterCheckboxList, setPrepopulateDefaultFilter, setSelectedTableSortOptions, setUpdatedDefaultFilter } from "redux/dashboardReducer";




const Header = (props) => {
  const { headerStructure ,downloadMISReportByFilter,clearAllFilter,
    value,
    handlePageClick,
    handleSearch,
    pagination,
    Download_icon,
    downloadEnable,
    currentUserRole,
    dashboardConfig,
    setRemoveFilter,
    searchBarConfig,
    filterDropdownList,
    setDefaultTextFilter,
    handleClearAllFilter

   } = props;
  const loggedInInfo = JSON.parse(localStorage.getItem("userToken"));

  const [toggleIcon, setToggleIcon] = useState(false);
  // const [isModalOpen, setisModalOpen] = useState(true);
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const [formErr, setFormErr] = useState({});
  const currentModule = useSelector((state) => state.dashboardReducer?.current_module);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const staticData = useSelector((state) => state.staticData);
  const selectedFilterCheckboxList = useSelector(state => state.dashboardReducer.selectedFilterCheckboxList);
  const selectedTableSortOptions = useSelector(state => state.dashboardReducer.selectedTableSortOptions);
  let loading = useSelector((state) => state?.dashboardReducer?.loadingAppplicantDataToDownload);
  const [searchValue, setSearchValue] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [show, setShow] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [saveFilter, setSaveFilter] = useState(false);
  const [key, setKey] = useState('All filters');
  const [saveFilters, setSaveFilters] = useState([]);
  const [userHierarchyData, setUserHierarchyData] = useState({});
  const [hierarchyCongigId, setHierarchyCongigId] = useState('');



  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true)

  const dispatch = useDispatch()
  const [moduleName, setModuleName] = useState('Module not found');

const downloadReportWithFilter =(days) => {
  const lastdate = new Date();
  lastdate.setDate(lastdate.getDate() - days);
  setSmShow(false)
  downloadMISReportByFilter(lastdate)
}
const handleSaveFilter = () => {
  const filterValeToSend = {};
  for (let filterKey in selectedFilterCheckboxList) {
    if (selectedFilterCheckboxList.hasOwnProperty(filterKey)) {
      // Checking if the filter is in the selectedFilterCheckboxList
      if (filterDropdownList[filterKey]) {
        // Sending the entire value of that filter
        filterValeToSend[filterKey] = filterDropdownList[filterKey].value;
      }
    }
  }
  let params = {
    text_filter: selectedFilterCheckboxList,
    sort_filter: selectedTableSortOptions,
    filter_name: selectedData?.name,
    default: selectedData?.default,
    user_id: loggedInInfo?.userId,
    role_id: loggedInInfo?.role,
    organisation_id: loggedInInfo?.userOrg,
    configuration_id: dashboardConfig?._id,
    module_id: currentModule?.id,
    filterValeToSend: filterValeToSend
  }
  dispatch(updateDashboardFilter(params))
  .unwrap()
  .then((res) => {
    if(res) {
      setSaveFilter(false);
      window.location.reload();
    }
  })
}
  const downloadIcon = ` <svg xmlns="http://www.w3.org/2000/svg" width="11.31" height="15.95" viewBox="0 0 11.31 15.95">
  <g id="Group_55264" data-name="Group 55264" transform="translate(-882.039 -51.465)">
    <path id="Path_57765" data-name="Path 57765" d="M15.447,15.907a.363.363,0,0,0,.567,0l4.728-5.639a.455.455,0,0,0,.07-.457.386.386,0,0,0-.354-.254H18.146V2.923a.445.445,0,0,0-.113-.3A.369.369,0,0,0,17.76,2.5H13.686a.406.406,0,0,0-.386.423V9.557H10.987a.389.389,0,0,0-.342.261.455.455,0,0,0,.074.45Zm-1.762-5.5a.369.369,0,0,0,.273-.124.445.445,0,0,0,.113-.3V3.346H17.39V9.98a.445.445,0,0,0,.113.3.369.369,0,0,0,.273.124h1.81l-3.855,4.592L11.876,10.4Z" transform="translate(871.963 49.215)" stroke="#000" stroke-width="0.5" />
    <path id="Path_57764" data-name="Path 57764" d="M.927,186c-.569,0-.569-1,0-1h9.957c.569,0,.569,1,0,1Z" transform="translate(881.789 -118.835)" stroke="#000" stroke-width="0.5" />
  </g>
</svg>`


  const [ctaContainerStyle, setCtaContainerStyle] = useState(2);
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const clientLogoutURL = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo
  )?.setting?.logout_url;

  let userToken = JSON.parse(localStorage.getItem("userToken"));
  const logout = async () => {
    let response = await storeLogoutToken(userToken);
    localStorage.clear();
    window.location.href = clientLogoutURL
      ? clientLogoutURL
      : "/accounts/login";
  };

  const workflowsTitle =
    dashboardConfig?.header_structure?.list_items
      ?.filter((item) => item.type === "nav_tabs" && item.name === "nav_tabs")
      ?.map((item) => item.fields[0]?.title) || [];


 



  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };
    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  }
  const validateAndSubmit = async() => {
    let validateFields = [];  
    formElement?.form_elements.map((item) => {
      let fieldVisiblity = false;
      if (item.hasOwnProperty("show"))
        fieldVisiblity = eval(item?.show);
      else fieldVisiblity = true;
      if (fieldVisiblity) {
        validateFields = [...validateFields, item];
      }
    });
    let errors;
    errors = await  validate(validateFields, selectedData, dispatch, staticData);
    if(selectedData?.name) {
      let findIndex = saveFilters?.findIndex((item) => item?.filter_name === selectedData?.name);
      if (findIndex !== -1) {
        errors = {
          name: {
            err: "Name can't be same."
          }
        }
        setFormErr(errors);
      } 
    }
    let errKeys = Object.keys(errors);
    if (errKeys?.length === 0) {
      handleSaveFilter();
    } else {
      setFormErr(errors);
    }
  };

  const SortFilter = (props) => {
    const {
      index,
      item,
      handleApplySort,
      icon
    } = props;
  
    const selectedTableSortOptions = useSelector(state => state.dashboardReducer.selectedTableSortOptions);
  
    const handleSort = (id) => {
      if(selectedTableSortOptions?.[id]) {
        let value = selectedTableSortOptions?.[id] || {};
        let data = Object?.keys(value)[0];
        handleApplySort(data, id);
      }
    }
  
    let aToZSortIcons = {
      "+1": `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sort-alpha-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z"/>
                <path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
              </svg>`,
      "-1": `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sort-alpha-down-alt" viewBox="0 0 16 16">
                <path d="M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645z"/>
                <path fill-rule="evenodd" d="M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371zm1.57-.785L11 9.688h-.047l-.652 2.156z"/>
                <path d="M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
              </svg>`
    }
  
    let updatedSortIcon = {
      "-1": `<svg xmlns="http://www.w3.org/2000/svg" width="16.96" height="14.733" viewBox="0 0 16.96 14.733">
    <g id="Group_49448" data-name="Group 49448" transform="translate(-1292.87 -419.171)">
      <g id="Group_49447" data-name="Group 49447" transform="translate(1300.499 422.584)">
        <path id="Path_55212" data-name="Path 55212" d="M16887.592-20946.475h3" transform="translate(-16890.236 20947.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2"/>
        <path id="Path_55213" data-name="Path 55213" d="M16887.588-20946.475h5" transform="translate(-16890.234 20950.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.8"/>
        <path id="Path_55214" data-name="Path 55214" d="M16887.588-20946.475h7" transform="translate(-16890.234 20953.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.7"/>
        <path id="Path_55215" data-name="Path 55215" d="M16887.59-20946.475h10" transform="translate(-16890.236 20956.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.6"/>
        <g id="Group_49449" data-name="Group 49449" transform="translate(-7.629)">
          <path id="Path_55061" data-name="Path 55061" d="M17.585,12.573l-1.258,1.258a.608.608,0,0,1-.88,0l-1.258-1.258a.623.623,0,0,1,.88-.88l.189.189V3.329a.629.629,0,0,1,1.258,0v8.553l.189-.189a.623.623,0,0,1,.88.88Z" transform="translate(-14 -2.7)"/>
        </g>
      </g>
      <text id="N" transform="translate(1309.83 427.171)" font-size="8" font-family="Outfit" font-weight="700"><tspan x="-5" y="0">N</tspan></text>
    </g>
  </svg>
  `,
      "+1": `<svg xmlns="http://www.w3.org/2000/svg" width="16.96" height="13.587" viewBox="0 0 16.96 13.587">
    <g id="Group_49451" data-name="Group 49451" transform="translate(-1292.87 -422.584)">
      <g id="Group_49447" data-name="Group 49447" transform="translate(1300.499 422.584)">
        <g id="Group_49452" data-name="Group 49452" transform="translate(-2.646 1.086)">
          <path id="Path_55212" data-name="Path 55212" d="M16887.592-20946.475h3" transform="translate(-16887.588 20955.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.6"/>
          <path id="Path_55213" data-name="Path 55213" d="M16887.588-20946.475h5" transform="translate(-16887.588 20952.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.7"/>
          <path id="Path_55214" data-name="Path 55214" d="M16887.588-20946.475h7" transform="translate(-16887.588 20949.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.8"/>
          <path id="Path_55215" data-name="Path 55215" d="M16887.59-20946.475h10" transform="translate(-16887.588 20946.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2"/>
        </g>
        <g id="Group_49449" data-name="Group 49449" transform="translate(-7.629)">
          <path id="Path_55061" data-name="Path 55061" d="M17.585,4.146,16.327,2.889a.608.608,0,0,0-.88,0L14.189,4.146a.623.623,0,0,0,.88.88l.189-.189v8.553a.629.629,0,0,0,1.258,0V4.838l.189.189a.623.623,0,0,0,.88-.88Z" transform="translate(-14 -2.7)"/>
        </g>
      </g>
      <text id="_0" data-name="0" transform="translate(1309.83 434.171)" font-size="8" font-family="Outfit" font-weight="700"><tspan x="-5" y="0">0</tspan></text>
    </g>
  </svg>
  `
    }
  
    let selectedIcon = eval(icon);
  
    return (
      <div
        className={`d-flex justify-content-between my-3 border-bottom border-2 ${selectedTableSortOptions?.[item?.id] && "cursor-pointer"}`}
        key={index}
        onClick={() => selectedTableSortOptions?.[item?.id] && handleSort(item?.id)}
      >
        <p className={`fs-13px fw-semibold ${!selectedTableSortOptions?.[item?.id] && "text-muted"}`}>{item?.name}</p>
        {Object?.keys(selectedTableSortOptions?.[item?.id] || {})?.[0] === "+1" ? (
          <span dangerouslySetInnerHTML={{ __html: selectedIcon?.["+1"] }}></span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: selectedIcon?.["-1"] }}></span>
        )}
      </div>
    );
  }

  const TextFilter = (props) => {
    const {
      optionList,
      index,
      item,
      handleRemoveFilter,
      setRemoveFilter
    } = props;
  
    const [showOptions, setShowOptions] = useState(false);
    const dispatch = useDispatch();
    const selectedFilterCheckboxList = useSelector(state => state.dashboardReducer.selectedFilterCheckboxList);
  
    const handleClearColumnFilter = (e, id) => {
      e.stopPropagation();
      let selectedFilter = structuredClone(selectedFilterCheckboxList);
      if(selectedFilter?.[id]) {
        delete selectedFilter?.[id];
      }
      let list = {};
      list.value = selectedFilter;
      list.type = id;
      dispatch(setFilterCheckboxList(list));
      setRemoveFilter(selectedFilter);
    }
  
    useEffect(() => {
      if(Object?.keys(selectedFilterCheckboxList)?.includes(item?.id)) {
        setShowOptions(true);
      } 
    }, [])
  
    return (
      <div key={index}>
        <div
          className={`d-flex justify-content-between my-3 cursor-pointer ${
            !showOptions && "border-bottom border-2"
          }`}
          onClick={() => optionList?.length && setShowOptions(!showOptions)}
        >
          <p className="fs-13px fw-semibold">
            {item?.name}
            <span className="text-muted mx-2">
              {optionList?.length ? `(${optionList?.length})` : "(0)"}
            </span>
          </p>
          <div className="d-flex justify-content-end">
            {optionList?.length ? (
              <p className="fs-13px fw-semibold cursor-pointer" onClick={(e) => handleClearColumnFilter(e, item?.id)}>
                <span className="text-muted mx-2">
                  {`Clear(${optionList?.length})`}
                </span>
              </p>
            ) : null}
            {showOptions ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="primary_button"
                class="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#E3E4E6"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            )}
          </div>
        </div>
        <div className="">
          {optionList?.length && showOptions
            ? optionList?.map((_item, _index) => {
                return (
                  <div
                    className={`d-inline-flex align-items-center mx-1 bg-light p-1 rounded-2 border ${_index} ${_index >= 0 ? 'mb-2':''}`}
                    key={_index}
                  >
                    <p className="mb-0 fs-12px mx-2">{_item}</p> 
                    <div onClick={() => handleRemoveFilter(_item, item?.id)} className="cursor-pointer">
                      <svg
                        className="mx-2"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-x"
                        viewBox="0 0 16 16"
                      >
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    );
  }

  const handleRemoveFilter = (option, id) => {
    let selectedFilterData = structuredClone(selectedFilterCheckboxList);
    let value
    value = filterDropdownList[id]?.value?.find((item) => item?.lable === option);
    if(!value){
      value = filterDropdownList[id]?.value?.find((item) => item?.placeholder === option);
    }
    if (filterDropdownList?.hasOwnProperty(id)) {
      if (!selectedFilterData?.hasOwnProperty(id) || selectedFilterData[id] == undefined) {
        selectedFilterData[id] = {};
        selectedFilterData[id][value?.id] = true;
      }else{
        if(selectedFilterData?.hasOwnProperty(id)){
          selectedFilterData[id][value?.id] = !selectedFilterData[id][value?.id]
        }
      }
    }
    let list = {};
    list.value = selectedFilterData;
    list.type = id;
    dispatch(setFilterCheckboxList(list));
    setRemoveFilter(selectedFilterData);
  }


  const handleClearFilter = () => {
    setShow(false);
    clearAllFilter();
  }


const SavedFilters = (props) => {
  const {
    setShow,
    saveFilters,
    setSaveFilters,
    module_id
  } = props;

  const dispatch = useDispatch();
  const loggedInInfo = JSON.parse(localStorage.getItem("userToken"));
  const dashboardFilter = useSelector((state) => state?.dashboardReducer?.dashboardFilter);
  const [defaultFound, setDefaultFound] = useState(false);

  const handleOptionClick = (item) => {
    let updatedFilter = [...saveFilters];
    let selectedFilter = updatedFilter?.find((filter) => filter?.checked);
    let selectedIndex = updatedFilter?.findIndex((filter) => filter?.checked);
    let checkedFilter = updatedFilter?.find((filter) => filter?.filter_id === item?.filter_id);
    let checkedIndex = updatedFilter?.findIndex((filter) => filter?.filter_id === item?.filter_id);
    let selected = {...selectedFilter};
    let checked = {...checkedFilter};
    if(selectedIndex === checkedIndex) {
      checked["checked"] = false;
      updatedFilter[checkedIndex] = checked;
    } else {
      selected["checked"] = false;
      checked["checked"] = true;
      updatedFilter[selectedIndex] = selected;
      updatedFilter[checkedIndex] = checked;
    }
    setSaveFilters(updatedFilter);  
  }

  const handleApplyFilter = () => {
    let defaultFilter = saveFilters?.find((item) => item?.checked);
    let params = {
      user_id: loggedInInfo?.userId,
      role_id: loggedInInfo?.role,
      new_default_id: defaultFilter?.filter_id,
      module_id: module_id
    }
    dispatch(checkAndChangeDefault(params))
    .unwrap()
    .then((res) => {
      if(res) {
        let newDefault = res?.filters?.find((item) => item?.is_default);
        if(newDefault) {
          dispatch(setUpdatedDefaultFilter(newDefault));
        } else dispatch(setUpdatedDefaultFilter({}));
        setShow(false);
        window.location.reload();
      }
    })
  }

  useEffect(() => {
    let defaultFilter = saveFilters?.find((item) => item?.is_default);
    if(defaultFilter) setDefaultFound(true);
    else setDefaultFound(false);
  }, []);
  
  return (
    <div className={`${classes['filter-container-height']} d-flex flex-column justify-content-between `}>
      {saveFilters?.length ? (
        <>
          <div className="overflow-y-scroll theme-scrollbar-hover">
            <p className={`${classes['text-primary-grey']} fs-15px m-3 fw-semibold`}>
              Recently used
            </p>
            <Form className="mx-1">
              <div className="border-bottom my-3">
                {saveFilters?.map((item, index) => {
                  if (item?.is_default) {
                    return (
                      <div key={index} onClick={() => handleOptionClick(item)} className="cursor-pointer">
                        <Form.Check
                          type={"radio"}
                          checked={item?.checked}
                          label={item?.filter_name}
                          className={`${classes['bg-grey-light']} py-2 my-3  px-5 fs-13px`}
                        />
                      </div>
                    );
                  }
                })}
                {!defaultFound && (
                  <div className={`${classes['bg-primary-warning']} d-flex align-items-center justify-content-center mx-2 my-3  py-1 rounded-2`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="#D49E05"
                      class="bi bi-exclamation-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                    </svg>
                    <p className= {`${classes['text-warning-search']} fs-13px mx-2 mb-0 mt-1 `}>
                      Default filter not selected.
                    </p>
                  </div>
                )}
              </div>
            </Form>
            <Form className="mx-1">
              <div className="mb-2 pb-3">
                {saveFilters?.map((item, index) => {
                  if (!item?.is_default) {
                    return (
                      <div key={index} onClick={() => handleOptionClick(item)} className="cursor-pointer">
                        <Form.Check
                          type={"radio"}
                          checked={item?.checked}
                          label={item?.filter_name}
                          className={`${classes['bg-grey-light']} py-2  px-5 mb-2 fs-13px`}
                        />
                      </div>
                    );
                  }
                })}
              </div>
            </Form>
          </div>
          <div className="d-flex justify-content-between align-items-center position-sticky bottom-0 bg-white py-2">
            <button
              className="fs-13px light_button"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
            <button
              className="btn text-white primary_button"
              onClick={handleApplyFilter}
            >
              Apply
            </button>
          </div>
        </>
      ) : (
        <div className={`${classes['not-found']} text-center`}>
          <img
            style={{
              objectFit: "contain",
              width: "70%",
              height: "70%",
            }}
            src={NoData}
            alt="No data found"
          />
          <p>No saved filter. Apply filter to save</p>
          <button
              className={`${classes['apply_filter_button']} fs-13px outline_button `}
              onClick={() => setShow(false)}
            >
              Apply Filter
          </button>
        </div>
      )}
    </div>
  );
}

  const handleFilter = () => {
    if(Object?.keys(selectedFilterCheckboxList)?.length || Object?.keys(selectedTableSortOptions)?.length) setSaveFilter(true);
  }
  
  const handleApplySort = (data, id) => {
    let selectedSortOptions = structuredClone(selectedTableSortOptions);    
    if(data === "+1") data = "-1";
    else if(data === "-1") data = "+1";
    selectedSortOptions[id] = {};
    selectedSortOptions[id][data] = true;
    dispatch(setSelectedTableSortOptions(selectedSortOptions));
  }

  const getOptionList = (option, id) => {
    let selectedOptions = [];
    if(Object?.keys(selectedFilterCheckboxList) && selectedFilterCheckboxList?.[id]) {
      Object?.entries(selectedFilterCheckboxList)?.map(([key, value]) => {
        if(key === id) {
          Object?.entries(value)?.map(([_key,_value]) => {
            if(_value) {
              let filter = filterDropdownList?.[id]?.value?.find((item) => item?.id === _key);
              selectedOptions = [...selectedOptions, filter?.lable ? filter?.lable : filter?.placeholder];
            }
          })
        }
      })
    }
    return selectedOptions;
  }


  const formElement = {
    form_elements: [
      {
        type: "subheader",
        name: "filter_label",
        sublabel: "Save filter as",
        label_style: "mx-2",
      },
      {
        type: "text",
        id: "name",
        label: "Enter name",
        size: "col-lg-12 col-md-12 col-sm-12 ",
        name: "name",
        placeholder: "Eg: ABC filter",
        show: "true",
        validators: {
          required: true,
          pattern: ["^[a-zA-Z0-9][a-zA-Z0-9-/ ]+$"],
          min_length: "",
          max_length: "25",
        },
        error_messages: {
          min_error: "You have to enter atleast <x> characters",
          max_error: "You can't enter more than 25 characters",
          pattern_error: "Please enter appropriate name",
          required_error: "Required",
        },
      },
      {
        type: "checkbox",
        id: "default",
        label: "Check to make it as default",
        size: "col-lg-12 col-md-12 col-12",
        name: "default",
        show: "true",
        options: [
          {
            label: "Yes",
            id: "yes",
            for: "yes",
          }
        ],
        validators: {
          required: "false",
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "This field is mandatory",
        },
      },
    ],
    form_buttons: [
      {
        label: "BACK",
        action: "handleBackFilter",
      },
      {
        label: "SAVE",
        action: "handleSaveFilter",
      },
    ],
  };

  useEffect(() => {
    if (dashboardConfig) {
      let headerStructure = dashboardConfig?.header_structure?.list_items;
      let filters = headerStructure?.find((item) => item?.type === "filters");
      let user_hierarchy = headerStructure?.find((item) => item?.type === "user_hierarchy");
      if (filters?.global_filter) {
        setShowFilter(true);
      } else setShowFilter(false);

      if(eval(user_hierarchy?.show)){
        setUserHierarchyData({
          show : true,
          listing_id:dashboardConfig?._id,
          ...user_hierarchy
        })
      } else{
        setUserHierarchyData({
          show : false,
          listing_id:'',
          ...user_hierarchy
         })
      }
    }
    // if (dashboardConfig?.sidebar_structure) {
    //   const moduleInfo = dashboardConfig?.sidebar_structure?.list_items.filter((item) => item?.list_name == "Workflows");
    //   setDownloadEnable(eval(moduleInfo[0]?.show));
    // }
  }, [dashboardConfig,currentModule])

  useEffect(() => {
    if(dashboardConfig) {
    dispatch(getDashboardFilters({
      user_id: loggedInInfo?.userId,
      role_id: loggedInInfo?.role,
      module_id: currentModule?.id,
    }))
    .unwrap()
    .then(async(res) => {
      if(res?.status === "success") {
        setSaveFilters(res?.data);
        let defaultFilter = res?.data?.find((item) => item?.is_default) || {};
        dispatch(setDefaultFilter(defaultFilter));
        if(Object?.keys(defaultFilter)?.length) {
          let text_filter = defaultFilter?.text_filter;
          let sort_filter = defaultFilter?.sort_filter;
          let text = {};
          let sort = {};
          let filterList = filterDropdownList;
            await dispatch(getFilterDropdownList({
              role_id: loggedInInfo?.role,
              module_id: currentModule?.id,
              organisation_id: loggedInInfo?.userOrg
            }))
            .unwrap()
            .then((res) => {
              filterList = res;
              dispatch(setAllFilterCheckBoxList(res));
            })
          if(Object?.keys(text_filter)?.length && filterList) {
            // console.log(filterDropdownList)
            Object?.entries(text_filter)?.map(([key, value])=> {
              let filter = filterList?.[key]?.value;
              let id = [];
              if(value?.length) {
                value?.map((item) => {
                  let filterId
                  if(item){
                    filterId = filter?.find((_item) => _item?.lable === item )?.id;
                  } else {
                    filterId = filter?.find((_item) => _item?.value === item)?.id;
                  }
                  id.push(filterId);
                })
              }
              let obj = {};
              id.map((value) => {
                obj[value] = true;
              })
              text[key] = obj;
            })
            setDefaultTextFilter(text);
            dispatch(setPrepopulateDefaultFilter(text));
          }else{
            setDefaultTextFilter({});
            dispatch(setPrepopulateDefaultFilter({}));
          }
          if(Object?.keys(sort_filter)?.length) {
            Object?.entries(sort_filter)?.map(([key, value])=> {
              let obj = {
                [value] : true
              }
              sort[key] = obj;
            })
            dispatch(setSelectedTableSortOptions(sort));
          }else{
            dispatch(setSelectedTableSortOptions({}))
          }
        }else{
          dispatch(setPrepopulateDefaultFilter({}));
          dispatch(setSelectedTableSortOptions({}));
        }

      } else {
        setSaveFilters([]);
        setDefaultTextFilter({});
        dispatch(setPrepopulateDefaultFilter({}));
        dispatch(setSelectedTableSortOptions({}));
      }
    })}
  }, [currentModule])

  useEffect(() => {
    const menuItems = dashboardConfig?.sidebar_structure?.list_items[0].menu_items;
    const matchedItem = menuItems?.find(item => item.module_id == currentModule?.id);
    setModuleName(matchedItem ? matchedItem.name : '');
  }, [currentModule]);
  
  const handleUserHiearchy = async (data) =>{
    if(data?.user_hierarchy_id && data?.listing_id){
        let encryptedListingId =   await encryptUrl(data?.listing_id)
        let encryptedHierarchyId = await encryptUrl(data?.user_hierarchy_id)
        window.location.href = `${data.routing_link}/${encryptedListingId}/${encryptedHierarchyId}`; // Redirects in the same page

    }
    
  }

  return (
    <>
      <div className="py-2 border-bottom d-flex justify-content-between align-items-center bg-white">
        <div className="fs-13px text-start ms-3 mt-1">{moduleName}</div>
        <div>
          <Dropdown
            className=" mx-3"
            onToggle={() => setToggleIcon(!toggleIcon)}
          >
            <Dropdown.Toggle
              variant="white"
              className="p-0 border-0 cursor-pointer"
              id="dropdown-basic"
            >
              <div className="d-flex align-items-center">
                {loggedInUserInfo?.profileInfo?.first_name != undefined && getProfilePicName(
                  loggedInUserInfo?.profileInfo?.first_name +
                  " " +
                  loggedInUserInfo?.profileInfo?.last_name
                )}
                <span className="ms-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6.647"
                    height="3.752"
                    viewBox="0 0 6.647 3.752"
                    className={`${toggleIcon ? "rotate-180deg" : ""}`}
                  >
                    <path
                      id="Path_54260"
                      data-name="Path 54260"
                      d="M3.323,0a.466.466,0,0,0-.329.135L.136,2.965a.458.458,0,0,0,0,.652.469.469,0,0,0,.658,0l2.529-2.5,2.529,2.5a.469.469,0,0,0,.658,0,.458.458,0,0,0,0-.652L3.653.135A.466.466,0,0,0,3.323,0Z"
                      transform="translate(6.647 3.752) rotate(180)"
                      fill="#757575"
                    />
                  </svg>
                </span>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu
              className="end-0 border-0 rounded-0 shadow-sm min-w-100px"
              style={{ left: "unset" }}
            >
              <Dropdown.Item
                className="bg-active-grey fs-14px"
                onClick={() => logout()}
              >
                Log out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <Navbar className="bg-white bg-theme-grey shadow-sm py-1">
        <Container fluid className="mx-2">
          <Nav className="me-auto">
            <Nav.Link className="fs-14px fw-bold text-dark nav-header position-relative active">
              {workflowsTitle}
            </Nav.Link>
          </Nav>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">

            <div className="d-lg-block d-md-block d-none">

              {Object?.keys(dashboardConfig || {})?.length ?
                (
                  <Search
                    className=".homepage_search"
                    value={searchValue}
                    handleSearch={handleSearch}
                    pagination={pagination}
                    Download_icon={Download_icon}
                    dashboardConfig={dashboardConfig}
                    clearAllFilter={handleClearAllFilter}
                    setRemoveFilter={setRemoveFilter}
                    searchBarConfig={searchBarConfig}
                    filterDropdownList={filterDropdownList}
                    setDefaultTextFilter={setDefaultTextFilter}
                  />
                ) : null
              }
            </div>
            <div className="border-end mx-3 border h-30px "></div>
            <div className="d-flex justify-content-center align-items-center">
                {userHierarchyData?.show  ?
               <div className="bg-hover-grey btn rounded-circle text-center cursor-pointer" onClick={() => handleUserHiearchy(userHierarchyData)}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip className="custom-tooltip">
                      <span className="fs-14px">User hierarchy</span>
                    </Tooltip>
                  }
                >
                  <div className="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.011"
                      height="17.031"
                      viewBox="0 0 17.011 17.031"
                    >
                      <path
                        id="Path_58498"
                        data-name="Path 58498"
                        d="M16.388,13.39V11.85a1.511,1.511,0,0,0-1.51-1.51H10.954V7.9a2.717,2.717,0,1,0-.6,0v2.446H6.425a1.511,1.511,0,0,0-1.51,1.51v1.54a2.717,2.717,0,1,0,.6,0V11.85a.907.907,0,0,1,.906-.906h8.454a.907.907,0,0,1,.906.906v1.54a2.717,2.717,0,1,0,.6,0ZM7.331,16.077a2.113,2.113,0,1,1-2.113-2.113A2.113,2.113,0,0,1,7.331,16.077ZM8.538,5.208a2.113,2.113,0,1,1,2.113,2.113A2.113,2.113,0,0,1,8.538,5.208Zm7.548,12.982A2.113,2.113,0,1,1,18.2,16.077,2.113,2.113,0,0,1,16.086,18.191Z"
                        transform="translate(-2.146 -2.127)"
                        stroke="#212121"
                        strokeWidth="0.7"
                      />
                    </svg>
                  </div>
                </OverlayTrigger>
              </div>
              :''}
              {downloadEnable ? (
                <>
                {loading ? (
                   <div
                   class="spinner-border text-theme fs-13px ms-2 d-none d-lg-block d-md-none d-sm-none"
                   id="download-loader"
                   role="status"
                 >
                   <span class="sr-only">Loading...</span>
                 </div>
                ) : ( 
                <button
                type="button"
                onClick={(e) => (loading ? {} : setSmShow(true))} className="btn bg-hover-grey rounded-circle text-center  cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11.31" height="15.95" viewBox="0 0 11.31 15.95">
                    <g id="Group_55264" data-name="Group 55264" transform="translate(-882.039 -51.465)">
                      <path id="Path_57765" data-name="Path 57765" d="M15.447,15.907a.363.363,0,0,0,.567,0l4.728-5.639a.455.455,0,0,0,.07-.457.386.386,0,0,0-.354-.254H18.146V2.923a.445.445,0,0,0-.113-.3A.369.369,0,0,0,17.76,2.5H13.686a.406.406,0,0,0-.386.423V9.557H10.987a.389.389,0,0,0-.342.261.455.455,0,0,0,.074.45Zm-1.762-5.5a.369.369,0,0,0,.273-.124.445.445,0,0,0,.113-.3V3.346H17.39V9.98a.445.445,0,0,0,.113.3.369.369,0,0,0,.273.124h1.81l-3.855,4.592L11.876,10.4Z" transform="translate(871.963 49.215)" stroke="#000" stroke-width="0.5" />
                      <path id="Path_57764" data-name="Path 57764" d="M.927,186c-.569,0-.569-1,0-1h9.957c.569,0,.569,1,0,1Z" transform="translate(881.789 -118.835)" stroke="#000" stroke-width="0.5" />
                    </g>
                  </svg>
                </button>)}
                </>
              ):''}
             
              {showFilter && (
                <>
                  <button onClick={handleShow} className="btn bg-hover-grey  rounded-circle text-center  cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.3" height="13" viewBox="0 0 14.3 13">
                      <g id="Page-1" transform="translate(0.65 0.65)">
                        <g id="Artboard">
                          <g id="filter">
                            <path id="Shape" d="M13,0H0L5.2,6.149V10.4l2.6,1.3V6.149Z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3" fill-rule="evenodd" />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </button>
                </>
              )}




            </div>
            <div className="border-end mx-3 border h-30px "></div>

            {/* Buttons */}
            <div className={`d-flex ${dashboardConfig?.header_structure?.list_items && dashboardConfig.header_structure.list_items.length > 2 ? 'onefr-onefr' : ''} gap-3`}>
              {dashboardConfig?.header_structure?.list_items?.map(
                (item, index) => {
                  if (IndirectEval(item?.show)) {
                    return (
                      <Fragment key={index}>
                        <DynamicForm
                          formFields={item}
                          formErr={formErr}
                          setFormErr={setFormErr}
                          selectedData={{ ...selectedData, currentUserRole: currentUserRole }}
                          setSelectedData={setSelectedData}
                        />
                      </Fragment>
                    );
                  }
                }
              )}
            </div>

           

            <Modal
          size=""
          show={smShow}
          onHide={() => setSmShow(false)}
          aria-labelledby="example-modal-sizes-title-sm"
        >
          <Modal.Body>
            <Row className="gy-3 gy-lg-0">
              <Col xs={12} md={12} lg={4}>
                <button
                  style={{ border: "none", background: "none" }}
                  type="button"
                  onClick={(e) => downloadReportWithFilter(7)}
                >
                  {" "}
                  <div className="d-flex align-items-center">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: downloadIcon,
                      }}
                    ></span>
                    <p className="mb-0 fs-15px ms-2 mt-1">Last 7 days</p>
                  </div>
                </button>
              </Col>
              <Col xs={12} md={12} lg={4}>
                <button
                  style={{ border: "none", background: "none" }}
                  type="button"
                  onClick={(e) => downloadReportWithFilter(15)}
                >
                  <div className="d-flex align-items-center">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: downloadIcon,
                      }}
                    ></span>
                    <p className="mb-0 fs-15px ms-2 mt-1">Last 15 days</p>
                  </div>
                </button>
              </Col>
              <Col xs={12} md={12} lg={4}>
                <button
                  style={{ border: "none", background: "none" }}
                  type="button"
                  onClick={(e) => downloadReportWithFilter(30)}
                >
                  <div className="d-flex align-items-center">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: downloadIcon,
                      }}
                    ></span>
                    <p className="mb-0 fs-15px ms-2 mt-1">Last 30 Days</p>
                  </div>
                </button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
            {/* <button
            style={{
              background: "none",
            }}
            className="download_button border btn px-1 py-0"
            type="button"
          >
            <>
              <div className="d-flex align-items-center justify-content-center">
                <span className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="noun-download-3465422"
                    width="17"
                    height="17"
                    viewBox="4 4 24 24"
                    fill="currentColor"
                    className="text-dark"
                  >
                    <path
                      id="Path_53898"
                      data-name="Path 53898"
                      d="M254.85,150.991a.5.5,0,0,0,.082.536l3.743,4.226a.515.515,0,0,0,.747,0l3.743-4.226a.5.5,0,0,0-.374-.83h-2.246v-4.509a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5V150.7h-2.246a.5.5,0,0,0-.455.295Z"
                      transform="translate(-243.549 -137.434)"
                    />
                    <path
                      id="Path_53899"
                      data-name="Path 53899"
                      d="M196,398.258a.749.749,0,0,0,.749.749h12.229a.749.749,0,1,0,0-1.5H196.749A.749.749,0,0,0,196,398.258Z"
                      transform="translate(-187.362 -377.262)"
                    />
                  </svg>
                </span>
              </div>
            </>
          </button> */}
            {/* Logout Logo */}
            {/* <Dropdown
              className="d-flex align-items-center justify-content-center"
              onToggle={() => setToggleIcon(!toggleIcon)}
            >
              <Dropdown.Toggle
                variant="white"
                className="p-0 border-0 cursor-pointer"
                id="dropdown-basic"
              >
                <div className="d-flex align-items-center">      
                  {loggedInUserInfo?.profileInfo?.first_name != undefined && getProfilePicName(
                    loggedInUserInfo?.profileInfo?.first_name +
                      " " +
                      loggedInUserInfo?.profileInfo?.last_name
                  )}
                  <span className="ms-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6.647"
                      height="3.752"
                      viewBox="0 0 6.647 3.752"
                      className={`${toggleIcon ? "rotate-180deg" : ""}`}
                    >
                      <path
                        id="Path_54260"
                        data-name="Path 54260"
                        d="M3.323,0a.466.466,0,0,0-.329.135L.136,2.965a.458.458,0,0,0,0,.652.469.469,0,0,0,.658,0l2.529-2.5,2.529,2.5a.469.469,0,0,0,.658,0,.458.458,0,0,0,0-.652L3.653.135A.466.466,0,0,0,3.323,0Z"
                        transform="translate(6.647 3.752) rotate(180)"
                        fill="#757575"
                      />
                    </svg>
                  </span>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="end-0 border-0 rounded-0 shadow-sm min-w-100px"
                style={{ left: "unset" }}
              >
                <Dropdown.Item
                  className="bg-active-grey fs-14px"
                  onClick={() => logout()}
                >
                  Log out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      
      {/* Mobile responsive new design */}
      <div className="d-flex justify-content-center align-items-center my-lg-0 my-4 mx-2">

        <div className="d-block d-md-none d-lg-none">

          {Object?.keys(dashboardConfig || {})?.length ?
            (
              <Search
                className=".homepage_search"
                value={searchValue}
                handleSearch={handleSearch}
                pagination={pagination}
                Download_icon={Download_icon}
                dashboardConfig={dashboardConfig}
                clearAllFilter={handleClearAllFilter}
                setRemoveFilter={setRemoveFilter}
                searchBarConfig={searchBarConfig}
                filterDropdownList={filterDropdownList}
                setDefaultTextFilter={setDefaultTextFilter}
              />
            ) : null
          }
        </div>

      </div>
      {saveFilter && (
        <>
          <Modal
            className="containermodal mt-1"
            show={saveFilter}
            onHide={() => setSaveFilter(false)}
            centered
            scrollable
            dialogClassName="modal-theme-scrollbar"
          >
            <Modal.Body className="p-4">
              {formElement?.form_elements?.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <DynamicForm
                      formFields={item}
                      formErr={formErr}
                      setFormErr={setFormErr}
                      selectedData={selectedData}
                      setSelectedData={setSelectedData}
                      clearFieldError={clearFieldError}
                    />
                  </Fragment>
                );
              })}
              <FormButton
                formButtons={formElement?.form_buttons}
                handleBackFilter={() => setSaveFilter(false)}
                handleSaveFilter={validateAndSubmit}
              />
            </Modal.Body>
          </Modal>
        </>
      )}
        <Offcanvas
                  show={show}
                  onHide={handleClose}
                  placement="end"
                  className="w-25 bg-transparent border-0"
                >
                  <div className="shadow">
                    <Offcanvas.Header closeButton className="bg-white">
                      <Offcanvas.Title className="text-theme fs-17px fw-bold">
                        Filter by
                      </Offcanvas.Title> 
                    </Offcanvas.Header>
                    <Offcanvas.Body className="bg-white">
                      <Tabs
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        id="uncontrolled-tab-example"
                        className="mb-3 border-bottom border-3 position-relative gap-4 search-tab"
                      >
                        <Tab
                          eventKey="All filters"
                          className="fs-15px mx-3"
                          title="All filters"
                        >
                          <div className={`${classes['filter-container-height']} d-flex flex-column justify-content-between`}>
                            <div className="overflow-y-scroll theme-scrollbar-hover pe-2">
                              <div className={`${classes['bg-primary-warning']} d-flex align-items-center justify-content-center mx-2  py-1 rounded-2`}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="#D49E05"
                                  class="bi bi-exclamation-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                                </svg>
                                <p className={`${classes['text-warning-search']} fs-13px mx-2 mb-0 mt-1 `}>
                                  These are the Columns with filter applied
                                </p>
                              </div>
                              {dashboardConfig?.fields?.map((item, index) => {
                                if (item?.filter_required) {
                                  if (item?.filter_type === "sort") {
                                    return (
                                      <SortFilter
                                        index={index}
                                        item={item}
                                        handleApplySort={handleApplySort}
                                        icon={
                                          item?.id === "full_name"
                                            ? "aToZSortIcons"
                                            : "updatedSortIcon"
                                        }
                                      />
                                    );
                                  } else if (item?.filter_type === "text") {
                                    let optionList =
                                      getOptionList(item?.options, item?.id) ||
                                      [];
                                    return (
                                      <TextFilter
                                        optionList={optionList}
                                        item={item}
                                        index={index}
                                        handleRemoveFilter={handleRemoveFilter}
                                        setRemoveFilter={setRemoveFilter}
                                      />
                                    );
                                  }
                                }
                              })}
                            </div>
                            <div className="d-flex justify-content-between bottom-0 position-sticky bg-white">
                              <button
                                className="btn light_button"
                                onClick={handleClearFilter}
                              >
                                Clear all
                              </button>
                              <button
                                className="primary_button btn text-white"
                                onClick={handleFilter}
                              >
                                Save as
                              </button>
                            </div>
                          </div>
                        </Tab>
                        <Tab eventKey="Saved filters" title="Saved filters">
                          <SavedFilters
                            setShow={setShow}
                            saveFilters={saveFilters}
                            setSaveFilters={setSaveFilters}
                            module_id={currentModule?.id}
                          />
                        </Tab>
                      </Tabs>
                    </Offcanvas.Body>
                  </div>
                </Offcanvas>
    </>
  );
};

export default Header;
